<template>
    <div class="copyright" v-if="baseInfo != null">
        <div class="container">
            <p>
                استفاده از مطالب فروشگاه اینترنتی {{baseInfo.ShopName}} فقط برای مقاصد غیرتجاری و با ذکر منبع بلامانع است.
                کلیه حقوق این سایت متعلق
                به  {{baseInfo.ShopName}} می‌باشد.
                <br />
                <span class="karasystak">طراحی و توسعه توسط  <a target="_blank" href="https://punas.ir/" title="طراحی وبسایت توسط پوناس">پوناس</a></span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;    
            }
        }
    }
</script>

<style scoped>
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .copyright p {
            text-align: justify;
            padding-bottom: 40px;
        }
    }
    @media only screen and (min-width: 641px) and (max-width: 1077px) {
        .copyright p {
            text-align: center;
            padding-bottom: 40px;
        }
    }
</style>